import { useEffect, useRef, useState } from 'react'
import styles from "./ShopHistory.module.scss"
import { Button, Col, Container, Row, Spinner } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux';
import { getPackagePurchaseHistory } from '../../../lib/store/actions';
import { useNavigate } from 'react-router-dom';
import LoaderCstm from '../../../components/Loader';
import { useWindow } from '../../../hooks/useWindow';
import moment from 'moment';
import { wait } from "../../../helper/common";
import InfiniteScroll from "react-infinite-scroll-component";
import ShopHistoryPop from '../../../components/Modals/ShopHistoryPop';

const ShopHistory = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [historyPop, setHistoryPop] = useState(false);
    const [transaction, setTransaction] = useState(null);
    const [scrollStopOn, setScrollStopOn] = useState(false);
    const { packagePurchaseHistory, loadingPurchaseHistory, totalPackageHistory } = useSelector(({ Energy }) => ({
        loadingPurchaseHistory: Energy.loadingPurchaseHistory,
        packagePurchaseHistory: Energy.packagePurchaseHistory,
        totalPackageHistory: Energy.totalPackageHistory,
    }));

    const [filter, setFilter] = useState({
        page: 1,
        limit: 20,
        order: -1,
        orderBy: "date_created_utc"
    });

    useEffect(() => {
        dispatch(getPackagePurchaseHistory({
            data: { ...filter }, callBack: (err, res) => {
                if (err) return;

            }
        }));
    }, [dispatch, filter]);

    const fetchMore = async () => {
        await wait(1000);
        setFilter((prev) => ({ ...prev, page: prev.page + 1 }));
    };

    const onClosePop = () => {
        setHistoryPop(false);
    };

    const { screenSize: { dynamicHeight } } = useWindow();
    const elementRef = useRef(null);

    useEffect(() => {
        const calculateScrollStop = () => {
            if (elementRef.current) {
                const elementHeight = elementRef.current.offsetHeight;
                console.log("Element height: $$$$$", elementHeight);
                console.log("Dynamic height: $$$$$", dynamicHeight);

                setScrollStopOn(dynamicHeight - 128 > elementHeight);
                calculateScrollStop();

                // Optional: Listen for window resize to update the calculation dynamically
                window.addEventListener("resize", calculateScrollStop);
                return () => window.removeEventListener("resize", calculateScrollStop);
            }
        };
    }, [dynamicHeight, packagePurchaseHistory]);

    return (
        <>
            <ShopHistoryPop
                show={historyPop}
                onHide={onClosePop}
                transaction={transaction}
            />
            <section className={`${styles.shopHistory} shopHistory ${scrollStopOn && totalPackageHistory <= 20 ? "no-minimize" : ""}`}>
                <Container>
                    <Row>
                        <Col lg="12" className="my-2">
                            <div className={`${styles.cardCstm} py-2 cardCstm`}>
                                <div className="top pb-3 text-center position-relative">
                                    <Button
                                        onClick={() => navigate("/shop")}
                                        className="border-0 p-0 position-absolute "
                                        variant="transparent"
                                        style={{ top: 0, left: 10 }}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="14"
                                            height="15"
                                            viewBox="0 0 14 20"
                                            fill="none"
                                        >
                                            <path
                                                d="M2.91436 9.76907L12.1877 2.01034C12.4158 1.81953 12.4158 1.5135 12.1877 1.32268C11.9596 1.13186 11.5939 1.13186 11.3658 1.32268L1.67935 9.42704C1.45128 9.61785 1.45128 9.92388 1.67935 10.1147L11.3658 18.2155C11.4777 18.3091 11.6283 18.3595 11.7746 18.3595C11.9209 18.3595 12.0715 18.3127 12.1834 18.2155C12.4115 18.0246 12.4115 17.7186 12.1834 17.5278L2.91436 9.76907Z"
                                                fill="white"
                                                stroke="white"
                                                stroke-width="2.26051"
                                            />
                                        </svg>
                                    </Button>
                                    <p
                                        className="m-0 fw-bold d-inline-block pb-1"
                                        style={{
                                            color: "#3ccece",
                                        }}
                                    >
                                        Purchase History
                                    </p>
                                </div>
                                {loadingPurchaseHistory && filter.page === 1 && <LoaderCstm />}
                                <InfiniteScroll
                                    className="allow-scroll"
                                    dataLength={packagePurchaseHistory?.length}
                                    next={fetchMore}
                                    hasMore={packagePurchaseHistory?.length < totalPackageHistory}
                                    scrollThreshold={0}
                                    scrollableTarget="historyList"
                                    loader={
                                        loadingPurchaseHistory &&
                                        filter.page >= 2 && (
                                            <div className="d-flex justify-content-center align-items-center">
                                                <Spinner className={styles.mSpinner} size="sm" />
                                            </div>
                                        )
                                    }
                                >
                                    <div id="historyList" className="table-responsive allow-scroll position-relative" style={{ overflowY: "scroll", height: "calc(100vh - 120px)" }}>
                                        <table ref={elementRef} className="table text-center"
                                        >
                                            <thead className='no-minimize'>
                                                <tr>
                                                    <th className="border-0 bg-transparent fw-normal">
                                                        ID
                                                    </th>
                                                    <th className="border-0 bg-transparent fw-normal">
                                                        Energy
                                                    </th>
                                                    <th className="border-0 bg-transparent fw-normal">
                                                        Amount
                                                    </th>
                                                    <th className="border-0 bg-transparent fw-normal">Status</th>
                                                    <th className="border-0 bg-transparent fw-normal">
                                                        Time
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody

                                            >
                                                {packagePurchaseHistory?.map((item, index) => (
                                                    <tr key={"history" + index}
                                                        onClick={() => {
                                                            setTransaction(item);
                                                            setHistoryPop(true);
                                                        }}>
                                                        <td className="border-0 bg-transparent px-2 py-3">
                                                            <h6 className="cursor-pointer m-0 fw-normal">
                                                                {item?.purchaseID}{" "}
                                                            </h6>
                                                        </td>
                                                        <td className="border-0 bg-transparent px-2 py-3">
                                                            <h6 className="m-0 fw-normal">
                                                                {item?.energy}
                                                            </h6>
                                                        </td>
                                                        <td className="border-0 bg-transparent px-2 py-3">
                                                            {<div className="d-flex align-items-center">
                                                                <span className="icn">
                                                                    {item?.amount?.toFixed(4) || 0}
                                                                    <img
                                                                        src={item?.currencyIcon}
                                                                        alt=""
                                                                        style={{ height: 18, width: 18, marginTop: "-3px", marginLeft: "3px" }}
                                                                        className=" img-fluid object-fit-contain"
                                                                    />
                                                                </span>
                                                            </div>}
                                                        </td>

                                                        <td className="border-0 bg-transparent">
                                                            <span className={`${item?.paymentStatus === "success" ? "text-success"
                                                                : item?.paymentStatus === "failed" ? "text-danger" : ""}`}>

                                                                {item?.paymentStatus?.charAt(0).toUpperCase() + item?.paymentStatus?.slice(1)}
                                                            </span>
                                                        </td>
                                                        <td className="border-0 bg-transparent px-2 py-3">
                                                            {item?.transactionCompletedAt &&
                                                                moment(item?.transactionCompletedAt).format(
                                                                    "DD.MM.YY HH:mm:ss"
                                                                )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </InfiniteScroll>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section >
        </>
    )
}

export default ShopHistory